// extracted by mini-css-extract-plugin
module.exports = {"CompaniesTable":"JiJsZGSW","companyContent":"_1ON6aiYO","companyHeader":"_1eYVm4DA","companyBottom":"_3-GUfPj2","candidateHeaderLeft":"_3miBOzPq","unverifiedStatus":"_1x6X5QGO","iconExplode":"_3aL50LQA","iconDanger":"_3sehV2tc","verifiedStatus":"_3Zg53kJt","actionsContent":"_2BhgY9Rw","nameHeader":"_1P_3dZ_i","statusHeader":"_19QWFGtz","candActionHeader":"_3qK1BXCt"};
    if(module.hot) {
      // 1754515039544
      var cssReload = require("!../../../../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  